export default {
  data() {
    return {
      carouselCanScrollLeft: false,
      carouselCanScrollRight: true,
      carouselIsDragging: false,
      carouselHasDragged: false,
      carouselStartX: 0,
      carouselScrollStartLeft: 0,
    }
  },
  computed: {
    carouselScrollButtonClass() {
      return 'tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-z-10 tw-bg-white tw-shadow tw-shadow-black/40 tw-border-0 tw-text-neutral-900 tw-rounded-full tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-cursor-pointer hover:tw-scale-105 tw-transition'
    },
  },
  mounted() {
    this.$nextTick(() => this.updateCarouselScrollState())
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onCarouselMouseMove)
    document.removeEventListener('mouseup', this.onCarouselMouseUp)
  },
  methods: {
    updateCarouselScrollState() {
      const el = this.$refs.carouselScrollContainer
      if (!el) return
      this.carouselCanScrollLeft = el.scrollLeft > 0
      this.carouselCanScrollRight =
        el.scrollLeft + el.clientWidth < el.scrollWidth - 2
    },
    getCarouselItemPositions() {
      const el = this.$refs.carouselScrollContainer
      if (!el) return []
      return Array.from(el.children).map(child => child.offsetLeft)
    },
    scrollCarouselLeft() {
      const el = this.$refs.carouselScrollContainer
      if (!el) return
      const positions = this.getCarouselItemPositions()
      const target = positions.reverse().find(pos => pos < el.scrollLeft - 1)
      el.scrollTo({ left: target ?? 0, behavior: 'smooth' })
    },
    scrollCarouselRight() {
      const el = this.$refs.carouselScrollContainer
      if (!el) return
      const positions = this.getCarouselItemPositions()
      const target = positions.find(pos => pos > el.scrollLeft + 1)
      if (target !== undefined) {
        el.scrollTo({ left: target, behavior: 'smooth' })
      }
    },
    onCarouselMouseDown(e) {
      const el = this.$refs.carouselScrollContainer
      if (!el) return
      this.carouselIsDragging = true
      this.carouselHasDragged = false
      this.carouselStartX = e.pageX
      this.carouselScrollStartLeft = el.scrollLeft
      el.style.cursor = 'grabbing'
      el.style.userSelect = 'none'
      document.addEventListener('mousemove', this.onCarouselMouseMove)
      document.addEventListener('mouseup', this.onCarouselMouseUp)
    },
    onCarouselMouseMove(e) {
      if (!this.carouselIsDragging) return
      const el = this.$refs.carouselScrollContainer
      if (!el) return
      const dx = e.pageX - this.carouselStartX
      if (Math.abs(dx) > 5) this.carouselHasDragged = true
      el.scrollLeft = this.carouselScrollStartLeft - dx
    },
    onCarouselMouseUp() {
      this.carouselIsDragging = false
      const el = this.$refs.carouselScrollContainer
      if (el) {
        el.style.cursor = 'grab'
        el.style.userSelect = ''
      }
      document.removeEventListener('mousemove', this.onCarouselMouseMove)
      document.removeEventListener('mouseup', this.onCarouselMouseUp)
    },
    onCarouselClickCapture(e) {
      if (this.carouselHasDragged) {
        e.stopPropagation()
        e.preventDefault()
      }
    },
  },
}
